import { useMutation, UseMutationResult } from '@tanstack/react-query';

import createMyProfile from '@/actions/my-profile/createMyProfile';
import { SaveMyProfileApiPayload } from '@/actions/my-profile/shared';
import { MyProfile } from '@/types/my-profile.type';
import { ApiResponse } from '@/types/response.type';

export interface UseCreateMyProfileReturn {
  mutate: (
    payload: SaveMyProfileApiPayload
  ) => Promise<ApiResponse<MyProfile> | undefined>;
  result: ApiResponse<MyProfile> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useCreateMyProfile = (): UseCreateMyProfileReturn => {
  const mutation: UseMutationResult<
    ApiResponse<MyProfile> | undefined,
    Error,
    SaveMyProfileApiPayload
  > = useMutation({
    mutationFn: createMyProfile,
  });

  return {
    mutate: mutation.mutateAsync,
    result: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
